import PropTypes from "prop-types"

import MenuItem from "@mui/material/MenuItem"
import Icon from "@mui/material/Icon"

import MDBox from "components/MDBox"
import MDTypography from "components/MDTypography"

import { useMaterialUIController } from "context"

// Tarjeta del Centro de Notificaciones: título + los datos del payload.
// El estado leído se refleja en el peso de la fuente y el color de fondo.
// Los colores se derivan del tema para soportar dark mode.
function NotificationCard({ notification, onClick }) {
  const [controller] = useMaterialUIController()
  const { darkMode } = controller
  const { title, payload = {}, read } = notification
  const { name, ci, branch, entryDate } = payload

  const unreadBg = darkMode ? "rgba(255, 255, 255, 0.05)" : "rgba(0, 0, 0, 0.03)"
  const borderColor = darkMode ? "rgba(255, 255, 255, 0.1)" : "rgba(0, 0, 0, 0.08)"

  return (
    <MenuItem
      onClick={() => onClick(notification.id)}
      sx={{
        display: "block",
        whiteSpace: "normal",
        borderBottom: `1px solid ${borderColor}`,
        backgroundColor: read ? "transparent" : unreadBg,
        py: 1,
      }}
    >
      <MDBox display="flex" alignItems="center" mb={0.5}>
        <MDTypography
          variant="button"
          color={darkMode ? "white" : "dark"}
          lineHeight={1}
          sx={{ display: "flex" }}
        >
          <Icon fontSize="small">notifications</Icon>
        </MDTypography>
        <MDTypography
          variant="button"
          fontWeight={read ? "regular" : "bold"}
          color={darkMode ? "white" : "dark"}
          sx={{ ml: 0.5 }}
        >
          {title}
        </MDTypography>
      </MDBox>
      <MDBox pl={0.5}>
        <Row label="Nombre" value={name} bold={!read} darkMode={darkMode} />
        <Row label="CI" value={ci} bold={!read} darkMode={darkMode} />
        <Row label="Sucursal" value={branch} bold={!read} darkMode={darkMode} />
        <Row label="Ingreso" value={entryDate} bold={!read} darkMode={darkMode} />
      </MDBox>
    </MenuItem>
  )
}

function Row({ label, value, bold, darkMode }) {
  return (
    <MDTypography
      variant="caption"
      display="block"
      fontWeight={bold ? "medium" : "regular"}
      color={darkMode ? "white" : "text"}
    >
      <strong>{label}:</strong> {value ?? "-"}
    </MDTypography>
  )
}

Row.propTypes = {
  label: PropTypes.string.isRequired,
  value: PropTypes.string,
  bold: PropTypes.bool,
  darkMode: PropTypes.bool,
}

NotificationCard.propTypes = {
  notification: PropTypes.shape({
    id: PropTypes.number.isRequired,
    title: PropTypes.string,
    read: PropTypes.bool,
    payload: PropTypes.shape({
      name: PropTypes.string,
      ci: PropTypes.string,
      branch: PropTypes.string,
      entryDate: PropTypes.string,
    }),
  }).isRequired,
  onClick: PropTypes.func.isRequired,
}

export default NotificationCard
